import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

const useTagsDetailQuery = (id: string) => {
  return useSuspenseQuery({
    queryKey: api.tag.getTagsByDocumentCategoryKey(id),
    queryFn: () => api.tag.getTagsByDocumentCategory(id),
  });
};

export default useTagsDetailQuery;
